import { IdvChannel } from '../../components/molecules/identity-verification/types'
import { COUNTRY_SHORTCODES } from '../../constants'
import { TemplateIds } from './templates'

type GetTemplateIdOptions = {
  isIDVReferral?: boolean
  isCitizen?: boolean
}

const getTemplateId = (
  vehicleType: string,
  country: keyof typeof COUNTRY_SHORTCODES,
  options: GetTemplateIdOptions
) => {
  let channel = ''
  switch (country) {
    case COUNTRY_SHORTCODES.JP:
      channel = options && options.isCitizen ? 'citizen' : 'non-citizen'
      return TemplateIds[COUNTRY_SHORTCODES.JP][channel][vehicleType]
    case COUNTRY_SHORTCODES.US:
    default:
      channel =
        options && options.isIDVReferral
          ? IdvChannel.REFERRAL
          : IdvChannel.NON_REFERRAL
      return TemplateIds[COUNTRY_SHORTCODES.US][channel][vehicleType]
  }
}

export default getTemplateId
